module.exports = __webpack_public_path__ + "img/vertical_6_4_3.cda470d8.png";